import React, { createContext, useContext, useState, useEffect } from 'react';
import { useCompany } from './CompanyContext';

interface SSEContextType {
  es: EventSource | null;
}

const SSEContext = createContext<SSEContextType | undefined>(undefined);

export const useSSE = (): SSEContextType => {
  const context = useContext(SSEContext);
  if (!context) {
    throw new Error('useSSE must be used within a SSEProvider');
  }
  return context;
};

interface SSEProviderProps {
  children: React.ReactNode;
}

export const SSEProvider = ({ children }: SSEProviderProps) => {
  const { companyId } = useCompany();
  const [es, setEs] = useState<EventSource | null>(null);

  useEffect(() => {
    if (!companyId) return;
    const base =
      process.env.REACT_APP_GS_FLY_PUBLIC_BACKEND_URL?.replace(/\/$/, '') || '';
    const url = `${base}/companies/live/${companyId}/events/`;
    const esInstance = new EventSource(url, { withCredentials: true });

    setEs(esInstance);

    return () => {
      esInstance.close();
      setEs(null);
    };
  }, [companyId]);

  return <SSEContext.Provider value={{ es }}>{children}</SSEContext.Provider>;
};
